import React, { Component, useEffect, useState } from 'react';
import WalletJournalsView from './WalletJournalsView';
import crmservices from '../../wsclient/crmservices';
import { getCurrency } from '../../utils/common';

function WalletJournals(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [transactions, setTransactions] = useState(null);
    const currency = getCurrency();
    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [paging, setPaging] = useState(null);
    const [transactionDetail, setTransactionDetail] = useState(null);
    const [showDetail, onShowDetail] = useState(false);

    useEffect(()=>{
        onLoadWalletTransactions(false)
    },[])
    
    const onLoadWalletTransactions = async (isRefresh) =>{
        onShowLoading(true);
        try {
            let result = await crmservices.account.getWaleltJournal();
            console.log("load wallet journal transactions:", result);
            if (result.code == 'OK') {
                setTransactions(result.data.content);
                setPaging(result.data.paging);
                if ( result.data.paging && result.data.paging.size < 10){
                    setHasMore(false);
                }
            }
        } catch (error) {
            console.log("load wallet journal transactions error:", error);
        }
        onShowLoading(false);
    }
    const handleLoadMore = async() =>{
        let page = paging.page+1
        setPaging(prevState =>({
            ...prevState,
            page: page
        }));
        onShowLoadMore(true);
        try {
            let result = await crmservices.account.getWaleltJournal({page: page});
            console.log('handleLoadMore transactions result=',result)
            if (result.code == 'OK') {
                setTransactions([...transactions,...result.data.content]);                
                if ( result.data.paging && result.data.paging.size < 10){
                    setHasMore(false);
                }
            }
            onShowLoadMore(false);
        } catch (error) {
            console.log("load wallet journal transactions error:", error);
        }
    }
    const onClickDetail = (item) =>{
        if (transactionDetail && transactionDetail.id && item.id === transactionDetail.id){
            onShowDetail(!showDetail)
        }
        else {
            setTransactionDetail(item);
            onShowDetail(true);
        }
    }
    return (
        <div>
            <WalletJournalsView 
                open={props.open} 
                handleDrawerOtherToggle= {props.onClose}
                transactions = {transactions}
                currency = {currency}
                handleLoadMore = {handleLoadMore}
                showLoadMore = {showLoadMore}
                hasMore= {hasMore}
                showLoading = {showLoading}
                onClickDetail = {onClickDetail}
                transactionDetail = {transactionDetail}
                showDetail={showDetail}/>
        </div>
    );
}

export default WalletJournals;